




















































































































































































































































































































































import Vue from 'vue'
import { mapActions, mapGetters } from 'vuex'
import { ModuleNames } from '@/store/module-names'
import { ActionNames as SiteActionNames } from '@/store/modules/site/keys'
import { GetterNames as SiteGetterNames } from '@/store/modules/site/keys'
import { FlatSite } from '@/store/modules/site/getters'
import { AdminSiteManagementBlankSite, AdminSiteManagementDefaultDevice } from '@/constants/admin-site-management'
import {
  DEFAULT_MATCH_RESIDENT_NUMBER,
  DEFAULT_MATCH_ROOM_NUMBER,
  DEFAULT_MY_PATIENTS_ENABLED,
  DEFAULT_PATIENT_MONITORING_ENABLED,
  DEFAULT_SYNC_ALL_PATIENTS,
  DEFAULT_SYNC_CAREGIVERS,
  DEFAULT_SYNC_MINIMAL_DATA,
  DEFAULT_SYNC_PATIENTS,
} from '@/utils/defaults'
import GenericDatePickerWrapper from '@/components/sub-components/GenericDatePickerWrapper.vue'

export default {
  components: { GenericDatePickerWrapper },
  props: {
    stageIndex: {
      type: Number,
      required: true,
    },
    site: {
      type: Object,
      required: false,
      default: null,
    },
    isSavingData: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
      isInitialLoading: true,

      siteName: null,
      org: null,
      regionalHealthAuthority: null,

      pccOrg: null,
      pccFacId: null,

      residexClientId: null,
      residexCampusId: null,

      kcPatientResourceType: null,

      glucometerProgramStartDate: null,
      glucometerProgramEndDate: null,
      vitalsProgramStartDate: null,
      vitalsProgramEndDate: null,

      patientMonitoringEnabled: DEFAULT_PATIENT_MONITORING_ENABLED,
      myPatientsEnabled: DEFAULT_MY_PATIENTS_ENABLED,

      syncPatientsFromEmr: DEFAULT_SYNC_PATIENTS,
      syncAllPatientsFromEmr: DEFAULT_SYNC_ALL_PATIENTS,
      syncMinimalPatientAttributes: DEFAULT_SYNC_MINIMAL_DATA,
      syncCaregiversFromEmr: DEFAULT_SYNC_CAREGIVERS,
      sharedDevicesMatchResidentNumber: DEFAULT_MATCH_RESIDENT_NUMBER,
      sharedDevicesMatchRoomNumber: DEFAULT_MATCH_ROOM_NUMBER,
    }
  },

  computed: {
    ...mapGetters(ModuleNames.site, {
      authorizedSites: `${SiteGetterNames.sites}`,
    }),
    authorizedSitesSorted() {
      return this.authorizedSites.slice().sort((a, b) => {
        return a.siteName.localeCompare(b.siteName)
      })
    },
    selectedSite: {
      get() {
        return this.site
      },
      set(value) {
        this.$emit('update:site', value)
      },
    },
  },

  async mounted(): Promise<void> {
    await Promise.all([this[SiteActionNames.getSites]()])
    this.isInitialLoading = false
    let s = this.sites
    this.emitValidStatus()
  },

  beforeUpdate: async function(): Promise<void> {
    this.emitValidStatus()
  },
  methods: {
    ...mapActions(ModuleNames.site, [SiteActionNames.getSites]),

    getSiteName(val: any): string {
      return `${val.siteName}`
    },

    emitValidStatus() {
      this.$emit('stageIsValid', {
        stageIndex: this.stageIndex,
        isValid: this.selectedSite!!,
      })
    },

    // emitSite() {
    //   this.$emit('update:site', this.site)
    //   // this.$emit('selectSite', this.selectedSite)
    // },

    addSiteRow() {
      this.selectedSite = AdminSiteManagementBlankSite
      // this.emitSitesAndValidStatus()
    },

    siteSelected(e) {
      this.$nextTick(() => {
        this.siteName = this.selectedSite.siteName
        this.org = this.selectedSite.org
        this.regionalHealthAuthority = this.selectedSite.regionalHealthAuthority
        this.pccOrg = this.selectedSite.pccOrg
        this.pccFacId = this.selectedSite.pccFacId

        this.residexClientId = this.selectedSite.residexClientId
        this.residexCampusId = this.selectedSite.residexCampusId

        this.glucometerProgramStartDate = this.selectedSite.glucometerProgramStartDate
        this.glucometerProgramEndDate = this.selectedSite.glucometerProgramEndDate
        this.vitalsProgramStartDate = this.selectedSite.vitalsProgramStartDate
        this.vitalsProgramEndDate = this.selectedSite.vitalsProgramEndDate

        this.patientMonitoringEnabled = this.selectedSite.patientMonitoringEnabled
        this.myPatientsEnabled = this.selectedSite.myPatientsEnabled
        this.syncPatientsFromEmr = this.selectedSite.syncPatientsFromEmr
        this.syncAllPatientsFromEmr = this.selectedSite.syncAllPatientsFromEmr
        this.syncMinimalPatientAttributes = this.selectedSite.syncMinimalPatientAttributes
        this.syncCaregiversFromEmr = this.selectedSite.syncCaregiversFromEmr
        this.sharedDevicesMatchResidentNumber = this.selectedSite.sharedDevicesMatchResidentNumber
        this.sharedDevicesMatchRoomNumber = this.selectedSite.sharedDevicesMatchRoomNumber

        this.kcPatientResourceType = this.selectedSite.kcPatientResourceType
        // this.emitSite()
        this.emitValidStatus()
      })
    },

    pccOrgInput(e) {
      console.log(e)
    },
    pccFacIdInput(e) {
      console.log(e)
    },

    residexClientIdInput(e) {
      console.log(e)
    },
    residexCampusIdInput(e) {
      console.log(e)
    },

    kcPatientResourceTypeInput(e) {
      console.log(e)
    },

    siteNameInput(e) {
      console.log(e)
    },

    orgInput(e) {
      console.log(e)
    },
    rhaInput(e) {
      console.log(e)
    },

    changeGlucometerProgramStartDate(e) {
      console.log(e)
      this.glucometerProgramStartDate = e || null
    },
    changeGlucometerProgramEndDate(e) {
      console.log(e)
      this.glucometerProgramEndDate = e || null
    },
    changeVitalsProgramStartDate(e) {
      console.log(e)
      this.vitalsProgramStartDate = e || null
    },
    changeVitalsProgramEndDate(e) {
      console.log(e)
      this.vitalsProgramEndDate = e || null
    },

    async saveSiteDetails() {
      console.log('saving site details')
      if (!this.selectedSite.id) {
        this.selectedSite.siteName = this.siteName
        this.selectedSite.org = this.org
      }
      this.selectedSite.regionalHealthAuthority = this.regionalHealthAuthority

      this.selectedSite.pccOrg = this.pccOrg
      this.selectedSite.pccFacId = this.pccFacId
      this.selectedSite.residexClientId = this.residexClientId
      this.selectedSite.residexCampusId = this.residexCampusId

      this.selectedSite.glucometerProgramStartDate = this.glucometerProgramStartDate
      this.selectedSite.glucometerProgramEndDate = this.glucometerProgramEndDate
      this.selectedSite.vitalsProgramStartDate = this.vitalsProgramStartDate
      this.selectedSite.vitalsProgramEndDate = this.vitalsProgramEndDate

      this.selectedSite.myPatientsEnabled = this.myPatientsEnabled
      this.selectedSite.patientMonitoringEnabled = this.patientMonitoringEnabled
      this.selectedSite.syncPatientsFromEmr = this.syncPatientsFromEmr
      this.selectedSite.syncAllPatientsFromEmr = this.syncAllPatientsFromEmr
      this.selectedSite.syncMinimalPatientAttributes = this.syncMinimalPatientAttributes
      this.selectedSite.syncCaregiversFromEmr = this.syncCaregiversFromEmr

      this.selectedSite.sharedDevicesMatchRoomNumber = this.sharedDevicesMatchRoomNumber
      this.selectedSite.sharedDevicesMatchResidentNumber = this.sharedDevicesMatchResidentNumber

      this.selectedSite.kcPatientResourceType = this.kcPatientResourceType
      this.$emit('uploadSite', this.selectedSite)
    },
  },
}
